import { render, staticRenderFns } from "./paymentRecord.vue?vue&type=template&id=3f061937&scoped=true&"
import script from "./paymentRecord.vue?vue&type=script&lang=js&"
export * from "./paymentRecord.vue?vue&type=script&lang=js&"
import style0 from "./paymentRecord.vue?vue&type=style&index=0&id=3f061937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f061937",
  null
  
)

export default component.exports